module.exports = __webpack_public_path__ + "img/prohibition.5e14d595.svg";